import { Controller, useFormContext } from 'react-hook-form'
import type { SupplierFormInput as FormInput } from './types'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import YesNoSwitch from 'ui/components/YesNoSwitch'
import { TextField, SelectField } from 'react-md'
import DatePickerISO from 'ui/components/DatePickerISO'
import { CreateFormGridItem } from '../../components'
//import { ErrorMessage } from 'ui/ManagerFinance/utils/components'
import type { SupplierFormInputs } from './validation'
import { requiredFormFields } from './validation'
import { NumericTextField } from 'ui/components/NumericTextField'

const FormSubHeading = styled.div`
	margin-top: 1rem;
	margin-bottom: 1rem;
	grid-column: span 2;
`

type SupplierFormInputProps = {
	input: FormInput
}

const SupplierFormInput = (props: SupplierFormInputProps) => {
	const {
		control,
		//watch,
		formState: { errors },
	} = useFormContext<SupplierFormInputs>()
	const intl = useIntl()
	const {
		show,
		//key, //TODO:
		title: _title,
		type,
	} = props.input

	let key = props.input.key as string

	const title = _title(intl)

	if (key === 'sub-heading') {
		return (
			<FormSubHeading key={`${key}-${title}`}>
				<h3 className="md-subheading-2" style={{ marginBottom: '0' }}>
					{title}
				</h3>
				<hr style={{ borderColor: 'rgba(0, 0, 0, 0.2)' }} />
			</FormSubHeading>
		)
	}

	if (show) {
		const isRequired = !!requiredFormFields.find((fieldKey) => fieldKey === key)
		// In an ideal case our input components would use forwardRef to expose their ref
		// in which case we could directly use {...register(key)} to register them as inputs,
		// which would directly "ingest" the value and onChange attributes.
		// But in the absence of this, we will use Controller wrappers
		if (type === 'string') {
			return (
				<CreateFormGridItem key={key} $fullWidth={false}>
					<Controller
						name={key}
						control={control}
						render={({ field: { value, onChange, onBlur } }) => (
							<TextField
								id={key}
								label={title}
								lineDirection="center"
								floating
								fullWidth
								disabled={false}
								error={errors[key] !== undefined}
								type="text"
								//@ts-ignore
								autoComplete="never-autocomplete"
								value={value as string}
								onChange={(val) => {
									onChange(val)
								}}
								required={isRequired}
								onBlur={(val) => {
									onBlur()
									onChange(val)
								}}
							/>
						)}
					/>
					{/*TODO: FIX errors[key]?.message && typeof errors[key]?.message === 'string' && (
						<ErrorMessage role="alert">{errors[key]?.message}</ErrorMessage>
					)*/}
				</CreateFormGridItem>
			)
		} else if (type === 'number') {
			return (
				<CreateFormGridItem key={key} $fullWidth={false}>
					<Controller
						name={key}
						control={control}
						render={({ field: { value, onChange, onBlur } }) => (
							<NumericTextField
								id={key}
								label={title}
								lineDirection="center"
								floating
								fullWidth
								error={errors[key] !== undefined}
								disabled={false}
								autoComplete="never-autocomplete"
								value={value as number}
								onChange={onChange}
								onBlur={() => {
									onBlur()
								}}
								//min={min}
								required={isRequired}
							/>
						)}
					/>
					{/*TODO: FIX errors[key]?.message && typeof errors[key]?.message === 'string' && (
						<ErrorMessage role="alert">{errors[key]?.message}</ErrorMessage>
					)*/}
				</CreateFormGridItem>
			)
		} else if (type === 'date') {
			return (
				<CreateFormGridItem key={key} $fullWidth={false}>
					<Controller
						name={key}
						control={control}
						render={({ field: { onChange, onBlur, value } }) => (
							<DatePickerISO
								style={{
									width: '100%',
									paddingTop: '5px',
								}}
								id={key}
								error={errors[key] !== undefined}
								label={title}
								value={value as string | Date}
								disabled={false}
								onChange={(date) => {
									onChange(date)
									onBlur()
								}}
								required={isRequired}
							/>
						)}
					/>
					{/*TODO: FIX errors[key]?.message && typeof errors[key]?.message === 'string' && (
						<ErrorMessage role="alert">{errors[key]?.message}</ErrorMessage>
					)*/}
				</CreateFormGridItem>
			)
		} else if (type === 'boolean') {
			return (
				<CreateFormGridItem key={key} $fullWidth={false}>
					<Controller
						name={key}
						control={control}
						render={({ field: { onChange, onBlur, value } }) => (
							<YesNoSwitch
								label={isRequired ? `${title} *` : title}
								name={key}
								checked={value as boolean}
								disabled={false}
								onChange={(bool) => {
									onChange(bool)
									onBlur()
								}}
								style={{
									marginTop: '10px',
								}}
								//TODO: required={isRequired}
							/>
						)}
					/>
				</CreateFormGridItem>
			)
		} else if (type === 'select') {
			return (
				<CreateFormGridItem key={key} $fullWidth={false}>
					<Controller
						name={key}
						control={control}
						render={({ field: { onChange, onBlur, value } }) => (
							<SelectField
								id={key}
								label={title}
								style={{
									width: '100%',
								}}
								//menuItems={menuItems ? menuItems(intl) : []} TODO:
								value={value?.toString()}
								onChange={(val) => {
									onChange(val)
									onBlur()
								}}
								required={isRequired}
							/>
						)}
					/>
				</CreateFormGridItem>
			)
		}
	}
	return null
}

export default SupplierFormInput
